module.exports = __webpack_public_path__ + "assets/ba2c6cb0af81f8da49a960db84f26b7c.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-400-normal.woff2
// module id = 2619
// module chunks = 121